import React, { useContext, useState } from 'react';

import styles from './DialogChangeStayTime.module.css';

import { getFullName } from '../../../services/getPatientAtribute';

import { useTranslation } from 'react-i18next';

import HourSelector from '../../UI/HourSelector/HourSelector';

import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider/LocalizationProvider';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment/AdapterMoment';
import ThemeProvider from '@mui/material/styles/ThemeProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker/DatePicker';
import createTheme from '@mui/material/styles/createTheme';
import { Moment } from 'moment';

import { Patient } from '../../../interfaces/Patient';
import { HH, mm } from '../../../interfaces/Time';
import useHttp from '../../../hooks/useHttp';
import { getEnvironmentApiUrl } from '../../../services/General';
import PatientsContext from '../../../context/PatientsContext';

interface Props {
    patient: Patient
    defaultTime: Moment
    timeStayString: string
    closeModal: () => void
}
const newTheme = createTheme({
    components: {
        MuiInputBase: {
            styleOverrides: {
                input: {
                    fontSize: '15px',
                    padding: '12px 0 12px 12px !important',
                    fontFamily: 'MontserratRegular'
                },
            },
        },
        MuiInputAdornment: {
            styleOverrides: {
                root: { margin: '0' }
            }
        }
    }
});

const DialogChangeStayTime: React.FC<Props> = ({
    patient,
    timeStayString,
    defaultTime,
    closeModal,
}) => {

    const { t } = useTranslation();

    const { error, sendRequest } = useHttp();

    const { setPatients } = useContext(PatientsContext);

    const [timeSelected, setTimeSelected] = useState(defaultTime);

    const changeDate = (newDate: Moment | null) => {
        if (newDate === null) return;
        setTimeSelected(oldTime => {
            const newTime = oldTime.clone();
            newTime.set('year', newDate.year());
            newTime.set('month', newDate.month());
            newTime.set('date', newDate.date());
            return newTime;
        });
    };

    const changeHour = (hours: HH | null, minutes: mm | null) => {
        setTimeSelected(oldTime => {
            const newTime = oldTime.clone();
            if (minutes) newTime.set('m', Number(minutes));
            if (hours) newTime.set('h', Number(hours));
            return newTime;
        });
    };

    const handleConfirm = () => {
        const caseID = patient.cases[0]?.id;
        if (caseID === undefined) return;
        const newDate = timeSelected.toISOString();
        sendRequest({
            url: getEnvironmentApiUrl() + 'case/' + caseID,
            method: 'PUT',
            body: {
                start_date: newDate,
            }
        }, () => {
            setPatients(oldPatients => {
                return oldPatients.map(p => {
                    if (p.id !== patient.id) return p;
                    const newCases = [...patient.cases];
                    newCases[0].start_date = newDate;
                    return {
                        ...p,
                        cases: newCases,
                    };
                });
            });
            closeModal();
        });
    };

    return (
        <div className='dialog'>
            <h1 className='dialogTitle'>
                {t('stay_time')}
            </h1>
            <h2 className='dialogSubTitle'>{getFullName(patient)}</h2>
            <p className={styles.subtitle}>
                {t('stay_time')}
            </p>
            <p className={styles.timeValue}>{timeStayString}</p>
            <p className={styles.subtitle}>
                {t('discharge_date')}
            </p>
            <LocalizationProvider dateAdapter={AdapterMoment}>
                <ThemeProvider theme={newTheme}>
                    <DatePicker
                        className={styles.datePicker}
                        defaultValue={timeSelected}
                        onChange={changeDate}
                        format='DD-MM-YYYY'
                    />
                </ThemeProvider>
            </LocalizationProvider>
            <p className={styles.subtitle}>
                {t('discharge_hour')}
            </p>
            <HourSelector
                hours={timeSelected.hour().toString() as HH}
                minutes={timeSelected.minute().toString() as mm}
                handleChange={changeHour}
                style={{
                    fontSize: '15px',
                    border: '1px solid #ccc',
                    borderRadius: '4px',
                    color: '#666',
                    padding: '12px',
                    justifyContent: 'space-between'
                }}
            />
            <p className={styles.error}>{error}</p>
            <div className={styles.buttonContainer}>
                <button
                    className='button btnPrimary'
                    onClick={handleConfirm}
                >
                    {t('confirm')}
                </button>
            </div>
        </div>
    );
};

export default DialogChangeStayTime;